export default function JsonMarquee({ config }) {
  if (!config || config.enabled === false) return null;
  const texts = Array.isArray(config.texts)
    ? config.texts.map((t) => String(t || "").trim()).filter(Boolean)
    : [];
  const single = String(config.text || "").trim();
  const list = texts.length ? texts : single ? [single] : [];
  if (!list.length) return null;

  const content = list.join("   \u2022   ");
  const duration = Number(config.speedSeconds) > 0 ? Number(config.speedSeconds) : 26;

  return (
    <div className="lfx-json-marquee" role="status" aria-live="polite">
      <div className="lfx-json-marquee-track" style={{ animationDuration: `${duration}s` }}>
        <span>{content}</span>
        <span aria-hidden>{content}</span>
      </div>
    </div>
  );
}
